import React from "react";
import { Steps as AntSteps } from "antd";
import { StepProps as AntStepProps } from "antd/lib/steps";

export class Step extends React.PureComponent<AntStepProps> {
  public render() {
    return <AntSteps.Step {...this.props} />;
  }
}
